<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>网站banner设置</h3>
                </el-col>
            </el-row>
            <el-form :model="bannerForm" ref="bannerForm" :rules="bannerFormFules">
                <el-form-item label="标题：" label-width="150px" v-if="bannerForm.value">
                    <el-input v-model="title"></el-input>
                </el-form-item>
                <el-form-item label="描述" label-width="150px" prop="description">
                    <el-input v-model="bannerForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="类型选择" label-width="150px" prop="shop">
                    <el-select v-model="type" placeholder="商品" @change="productChoose">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="视频链接" label-width="150px" v-if="bannerForm.value && type === 'video'">
                    <el-input v-model="videoUrl"></el-input>
                </el-form-item>
                <el-form-item label="视频封面" label-width="150px" v-if="bannerForm.value && type === 'video'">
                    <el-upload class="avatar-uploader" action="https://upload.qiniup.com/" :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="uptoken">
                        <img v-if="imgUrl" :src="imgUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="封面图：" label-width="150px" v-if="type === 'pic'">
                    <el-upload action="https://upload.qiniup.com/" :file-list="fileListDetail" :on-error="handleError" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleDetailRemove" :on-success="handleDetailSuccess" :before-upload="beforeDetailUpload"
                        :data="uptoken">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog v-model="dialogVisible" size="tiny">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label-width="150px">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    
    </div>
</template>

<script>
    import {
        getBanner,
        putBanner
    } from '../../api/version'
    
    export default {
        data() {
            return {
                bannerForm: {},
                dialogVisible: false,
                dialogImageUrl: '',
                videoUrl: '',
                imgUrl: '',
                bannerFormFules: {
                    name: [{
                        required: true,
                        message: '请输入享玩甄选描述',
                        trigger: 'blur'
                    }],
                    shop: [{
                        type: 'number',
                        required: true,
                        message: '请选择商品',
                        trigger: 'blur'
                    }]
                },
                options: [{
                    value: 'video',
                    label: '视频'
                }, {
                    value: 'pic',
                    label: '图片'
                }, ],
                uptoken: {
                    token: sessionStorage.token
                },
                productArr: [],
                imageUrl: '',
                fileListDetail: [],
                type: 'video',
                title: '',
                picArr: [],
                videoData: ''
            }
        },
        created() {
            getBanner(JSON.stringify({
                'where': {
                    'version': 'home_banner'
                }
            })).then(res => {
                console.log(res)
                this.bannerForm = res.data[0]
                this.type = res.data[0].value.type
    
                if (this.bannerForm.value.type === 'pic') {
                    this.title = res.data[0].value.content[0].title
                    this.bannerForm.value.content.forEach(item => {
                        this.fileListDetail.push({
                            url: item.imgUrl
                        })
                    })
                } else {
                    this.title = res.data[0].value.content.title
                    this.videoUrl = res.data[0].value.content.videoUrl
                    this.imgUrl = res.data[0].value.content.imgUrl
                }
            })
        },
        methods: {
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleDetailSuccess(res, file) {
                this.picArr.push({
                    imgUrl: `https://img.shareplay.cc/${res.key}`,
                    title: this.title
    
                })
            },
            handleAvatarSuccess(res, file) {
                this.upImage = `https://img.shareplay.cc/${res.key}`
                this.imgUrl = `https://img.shareplay.cc/${res.key}`
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                this.uptoken = {
                    token: sessionStorage.token
                }

                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleError() {
                this.$message.error('请重新登录')
                this.$router.push('/login')
            },
            beforeDetailUpload() {
    
            },
            productChoose(val) {
                console.log(val)
            },
            handleDetailRemove(file, fileList) {
                console.log(file);
                console.log(fileList[0].response);
                let arr = []
                fileList.forEach(item => {
                    arr.push({
                        imgUrl: `https://img.shareplay.cc/${item.response.key}`,
                        title: this.title
                    })
                })
                this.picArr = arr
            },
            onSubmit() {
    
                if (this.type === 'pic') {
                    if (this.picArr.length) {
                        delete this.bannerForm.id
                        this.bannerForm.value.type = 'pic'
                        this.bannerForm.value.content = JSON.parse(JSON.stringify(this.picArr))
                        putBanner(sessionStorage.userId, 13, this.bannerForm).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                            }
                        })
                    }
                } else if (this.type === 'video') {
                    this.bannerForm.value.type = 'video'
                    this.videoData = JSON.parse(JSON.stringify(this.bannerForm))
                    delete this.videoData.content
                    this.videoData.value.content = {
                        videoUrl: this.videoUrl,
                        title: this.title,
                        imgUrl: this.imgUrl
                    }
                    delete this.videoData.id
                    putBanner(sessionStorage.userId, 13, this.videoData).then(res => {
                        console.log(res.data)
                        if (res.data) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                    })
                }
    
    
    
            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// Banner.vue?0b56a4cc